module.exports = __webpack_public_path__ + "img/icon_upgrade.d1632df6.svg";